import {
    MyAccountOrderCardComponent,
    myAccountOrderCardHeaderProps,
    myAccountOrderCardInfoProps,
    myAccountOrderEdgeToEdge,
    myAccountOrderGridItemCss,
    myAccountOrderHeaderProps,
} from "@affinity/components/MyAccount/myAccountOrderCardStyles";
import loadMyAccountOrders from "@affinity/Handlers/LoadMyAccountOrders";
import { CustomState } from "@affinity/Store/Reducers";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";


const enum fields {
    showAll = "showAll",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showAll]: boolean;
    };
}

const mapStateToProps = (state: CustomState) => {
    const pageSize = 10;
    const billToId = state.context.session.billToId ?? "";
    return {
        completedOrders: state.affinity_my_account?.completedOrders,
        totalCompletedOrders: state.affinity_my_account?.totalCompletedOrders,
        isLoading: state.affinity_my_account?.isLoading ?? false,
        pageSize,
        billToId,
    };
};

const mapDispatchToProps = {
    loadMyAccountOrders,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const CompletedOrders: FC<Props> = ({
    completedOrders,
    totalCompletedOrders,
    isLoading,
    pageSize,
    billToId,
    loadMyAccountOrders,
    fields
}) => {

    if (!completedOrders && !isLoading) {
        loadMyAccountOrders({ pageSize, billToId });
    }  

    const displayList = fields.showAll ? completedOrders : completedOrders?.map((o)=>o).splice(0,3);
    if (!isLoading && displayList) {
        return (
            <GridContainer css={myAccountOrderEdgeToEdge}>
                <GridItem width={12}>
                    <Typography {...myAccountOrderHeaderProps}>
                        Completed Orders ({totalCompletedOrders})
                    </Typography>
                </GridItem>
                <GridItem width={12}>
                    <GridContainer >
                        {displayList.map((order) => {
                            return <GridItem key={order.orderLineId} width={[12, 12, 6, 4, 4]} css={myAccountOrderGridItemCss}>
                                <MyAccountOrderCardComponent>
                                    <Typography {...myAccountOrderCardHeaderProps}>
                                        {order.name}
                                    </Typography>
                                    <Typography {...myAccountOrderCardInfoProps}>
                                        Order Number: {order.id}
                                    </Typography>
                                    <Typography {...myAccountOrderCardInfoProps}>
                                        {order.address}
                                    </Typography>
                                    <Typography {...myAccountOrderCardInfoProps}>
                                        {order.amount} litres
                                    </Typography>
                                    {/*
                                    <Typography {...myAccountOrderCardInfoProps}>
                                        Delivery due {(new Date (order.deliveryDue)).toLocaleDateString('en-GB')}
                                    </Typography>
                                    */}
                                </MyAccountOrderCardComponent>
                            </GridItem>
                        })}
                    </GridContainer>
                </GridItem>
            </GridContainer>
        );
    }

    return (
        <><LoadingSpinner/></>
    )
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CompletedOrders),
    definition: {
        allowedContexts: ["HomePage", "MyAccountPage", "OrderHistoryPage"],
        group: "My Account",
        displayName: "Completed Orders",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.showAll,
                editorTemplate: "CheckboxField",
				displayName: "Show all orders",
                defaultValue: false,
            },
        ]
    },
};

export default widgetModule;
